import React from "react";
import { ExemptionFormTypeEnum } from "../../../shared/enums/exemption-form-type-enum";
import DrivingExemptionPage from "./DrivingExemptionPage";
import { lvCommuteExemptionForm } from "./DrivingExemptionPageSelector";
import FormContents from "./FormContents";

const LvCommuteExemptionForm = () => {
    return (
        <DrivingExemptionPage selectedPage={lvCommuteExemptionForm}>
            <FormContents formType={ExemptionFormTypeEnum.LVCommute}></FormContents>
        </DrivingExemptionPage>
    );
}

export default LvCommuteExemptionForm;